import { render, staticRenderFns } from "./LearnContent.vue?vue&type=template&id=55062243&scoped=true&"
import script from "./LearnContent.vue?vue&type=script&lang=ts&"
export * from "./LearnContent.vue?vue&type=script&lang=ts&"
import style0 from "./LearnContent.vue?vue&type=style&index=0&id=55062243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55062243",
  null
  
)

export default component.exports